import { EventType } from 'lib/EventSchema';
import { EventData } from 'lib/EventLogger/Event';
import { SharedEventInfo } from 'lib/Tracking/types';

export function MakeModelTap({ sourcePage, feature }: SharedEventInfo): EventData {
  return {
    event_type: EventType.engagement,
    source_page: sourcePage,
    feature,
    engagement_type: `make_model_tap`,
    event_context: {},
  };
}

export function FilterMakesTap({ sourcePage, feature }: SharedEventInfo): EventData {
  return {
    event_type: EventType.engagement,
    source_page: sourcePage,
    feature,
    engagement_type: `filter_makes_tap`,
    event_context: {},
  };
}

export function MakeTap({ sourcePage, feature }: SharedEventInfo): EventData {
  return {
    event_type: EventType.engagement,
    source_page: sourcePage,
    feature,
    engagement_type: `make_tap`,
    event_context: {},
  };
}

export function FilterModelsTap({ sourcePage, feature }: SharedEventInfo): EventData {
  return {
    event_type: EventType.engagement,
    source_page: sourcePage,
    feature,
    engagement_type: `filter_models_tap`,
    event_context: {},
  };
}

export function ModelTap({ sourcePage, feature }: SharedEventInfo): EventData {
  return {
    event_type: EventType.engagement,
    source_page: sourcePage,
    feature,
    engagement_type: `model_tap`,
    event_context: {},
  };
}
